import axios from "axios";
import { settings } from "../config/settings";

/** Axios instance used for DMQT API calls (exported for unit tests). */
export const apiClient = axios.create();

apiClient.interceptors.request.use((config) => {
  config.baseURL = settings.dmqtApiHost || undefined;
  return config;
});

// Function to handle errors uniformly
const handleError = (error) => {
  if (error.response) {
    console.error(
      `API Error: ${error.response.status} - ${error.response.statusText}`,
    );
  } else if (error.request) {
    console.error("No response received from API:", error.request);
  } else {
    console.error("Error setting up request:", error.message);
  }
  throw error; // Re-throw to allow calling functions to handle it
};

// GET request function
// Added optional customHeaders parameter, merging with existing code
export const getData = async (endpoint, customHeaders = {}) => {
  try {
    // console.log('Custom headers (GET):', customHeaders)
    const response = await apiClient.get(endpoint, {
      headers: {
        ...customHeaders,
      },
    });
    if (response.status !== 200) {
      throw new Error(`Unexpected status code: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// POST request function
// Added optional customHeaders parameter, merging with existing code
export const postData = async (endpoint, data, customHeaders = {}) => {
  try {
    // console.log('Custom headers (POST):', customHeaders)
    const response = await apiClient.post(endpoint, data, {
      headers: {
        ...customHeaders,
      },
    });
    if (response.status < 200 || response.status >= 300) {
      throw new Error(`Unexpected status code: ${response.status}`);
    }
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
